import React, { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { Text } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import Skeleton from '@shared/v2/components/Skeleton';

import Button from '@/components/Button';
import { SCREEN_SIZE } from '@/lib/theme/breakPoints';
import { useGA4Events } from '@/v2/hooks/featureFlags/ga4Events/useGA4Events';
import { dataLayer } from '@/v2/utils/dataLayer';

export type CTAButtonProps = Omit<ComponentProps<typeof Button>, 'children'> & {
  text: string;
};

const StyledButton = styled(Button)`
  padding: 8px 24px;

  ${SCREEN_SIZE.MD} {
    padding: 12px 32px;
  }

  &:disabled {
    background: ${themeGet('colors.white')};
    border-color: ${themeGet('colors.greys.dusty')};
    color: ${themeGet('colors.greys.dusty')};
  }
`;

const CTAButton = ({ text, onClick, ...props }: CTAButtonProps) => {
  const shouldUseNewEvents = useGA4Events();

  const onCtaClick = () => {
    if (shouldUseNewEvents) {
      dataLayer.ctaClickEvent({
        itemText: text,
      });
    }
    onClick();
  };
  return (
    <Skeleton mt="2" width="100%" height={['41px', null, '48px']}>
      <StyledButton
        mt="2"
        width="100%"
        outline
        nowrap
        onClick={onCtaClick}
        {...props}
      >
        <Text lineHeight="20px" fontSize={['xs', null, 'sm']}>
          {text}
        </Text>
      </StyledButton>
    </Skeleton>
  );
};

export default CTAButton;
